"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBgStyles = getBgStyles;
function getBgStyles(settings, isShowingLayoutBgColor) {
  var imageUrl = settings.imageUrl,
    imageStyle = settings.imageStyle,
    imageWidth = settings.imageWidth;
  if (isShowingLayoutBgColor && imageUrl && imageStyle === 'cover') {
    return {
      backgroundImage: "url(".concat(imageUrl, ")"),
      backgroundSize: 'cover',
      backgroundPosition: 'center center'
    };
  }
  if (isShowingLayoutBgColor && imageUrl && imageStyle === 'tile') {
    return {
      backgroundImage: "url(".concat(imageUrl, ")"),
      backgroundSize: imageWidth,
      backgroundRepeat: 'repeat'
    };
  }
  return {};
}